/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { FormDefinitionResponse } from '../models/form-definition-response';

/**
 * Form Metadata APIs
 */
@Injectable({ providedIn: 'root' })
export class FormMetadataService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getClientPortalFormDefinitions()` */
  static readonly GetClientPortalFormDefinitionsPath =
    '/api/v1/metadata/forms/client-portal/defenitions';

  /**
   * Get form definitions for client-portal.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getClientPortalFormDefinitions()` instead.
   *
   * This method doesn't expect any request body.
   */
  getClientPortalFormDefinitions$Response(
    params?: {},
    context?: HttpContext
  ): Observable<StrictHttpResponse<FormDefinitionResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      FormMetadataService.GetClientPortalFormDefinitionsPath,
      'get'
    );
    if (params) {
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<FormDefinitionResponse>;
        })
      );
  }

  /**
   * Get form definitions for client-portal.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getClientPortalFormDefinitions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getClientPortalFormDefinitions(
    params?: {},
    context?: HttpContext
  ): Observable<FormDefinitionResponse> {
    return this.getClientPortalFormDefinitions$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<FormDefinitionResponse>
        ): FormDefinitionResponse => r.body
      )
    );
  }
}
